//@flow
import type { FieldsType, InputFile } from 'types/ContactForm7';

//* Functions not specific to CF7 but needed for it to work
export function isEmpty(value: any) {
  return value === undefined || value === null || value === '';
}

export function isEmailValid(email: string): boolean {
  // eslint-disable-next-line
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

//* Functions specific to CF7
export function getFieldType(fieldType: string) {
  return fieldType.indexOf('*') !== -1 ? fieldType.slice(0, fieldType.indexOf('*')) : fieldType;
}

export function getCF7ClassesData(arrayCF7ClassesData: Object[], slug: string, fieldType: string) {
  const data = arrayCF7ClassesData.find(item => {
    return (
      (item.formNames.includes(slug) && item.fieldTypeList.includes(fieldType)) ||
      (item.formNames.includes('') && item.fieldTypeList.includes(fieldType))
    );
  });

  return data;
}

// ContactForm7/CF7Form
// FILES
const DEFAULT_TYPE = [
  'jpg',
  'jpeg',
  'png',
  'gif',
  'pdf',
  'doc',
  'docx',
  'ppt',
  'pptx',
  'odt',
  'avi',
  'ogg',
  'm4a',
  'mov',
  'mp3',
  'mp4',
  'mpg',
  'wav',
  'wmv'
];

const ONE_BYTE = 1024;
const CF7_MAX_SIZE = 1024 * 1024;

function getSimpleTypeFromMimeType(mimetype: string) {
  return mimetype.split('/')[1].trim();
}

// ! @todo = > sera à faire grossir au besoin en parallèle de getMimeFormat
function getMime(format: string) {
  let mimeType = '';

  switch (format) {
    case 'doc':
      mimeType = 'application/msword';
      break;
    case 'docx':
      mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
      break;
    case 'jpg':
      mimeType = 'image/jpeg';
      break;
    case 'pdf':
      mimeType = 'application/pdf';
      break;
    default:
      break;
  }

  return mimeType;
}

// ! @todo = > sera à faire grossir au besoin en parallèle de getMime
function getMimeFormat(format: string) {
  let mimeType = '';

  switch (format) {
    case 'doc':
      mimeType = 'msword';
      break;
    case 'docx':
      mimeType = 'vnd.openxmlformats-officedocument.wordprocessingml.document';
      break;
    case 'jpg':
      mimeType = 'jpeg';
      break;
    case 'pdf':
      mimeType = 'pdf';
      break;
    default:
      break;
  }

  return mimeType;
}

export function isFileTypeIncorrect(file: InputFile, field: FieldsType) {
  const fileTypesOption = field.options.find(option => option.startsWith('filetypes:'));
  let fileTypes = fileTypesOption
    ? fileTypesOption
        .split(':')[1]
        .split('|')
        .map(o => o.trim())
    : '';

  if (!fileTypes) {
    return DEFAULT_TYPE.includes(file.type);
  } else {
    fileTypes = fileTypes.map(format => getMimeFormat(format));
  }

  const mimeType = getSimpleTypeFromMimeType(file.type);

  return !fileTypes.includes(mimeType);
}

function getBytesFromLimit(limit: string) {
  if (limit.match(/^[0-9]+$/)) {
    return parseInt(limit, 10);
  } else if (limit.match(/^[0-9]+kb$/i)) {
    return parseInt(limit, 10) * ONE_BYTE;
  } else if (limit.match(/^[0-9]+mb$/i)) {
    return parseInt(limit, 10) * ONE_BYTE * ONE_BYTE;
  }

  return CF7_MAX_SIZE;
}

export function isFileSizeIncorrect(file: InputFile, field: FieldsType) {
  const limitOption = field.options.find(option => option.startsWith('limit:'));
  const limit = limitOption ? limitOption.split(':')[1].trim() : '';
  const limitInBytes = limit ? getBytesFromLimit(limit) : CF7_MAX_SIZE;

  return file.size >= limitInBytes;
}

// ContactForm7/Field
export function getPropsFromOptions(field: FieldsType) {
  const props = {};

  let hasPlaceholder = false;

  field.options.forEach((option: string) => {
    const [key, value] = option.split(':');

    switch (key) {
      case 'id':
        props.id = value;
        break;
      case 'class':
        props.className = value;
        break;
      case 'placeholder':
      case 'watermark':
        props.placeholder = field.values;
        hasPlaceholder = true;
        break;

      // input text
      case 'minlength':
        props.minLength = value;
        break;
      case 'maxlength':
        props.maxLength = value;
        break;
      case 'size':
        props.size = value;
        break;
      case 'akismet':
        break;

      // input number
      case 'min':
        props.min = value;
        break;
      case 'max':
        props.max = value;
        break;
      case 'step':
        props.step = value;
        break;

      // input file
      case 'filetypes':
        let formatedAuthorizedFileFormats = value.split('|');
        formatedAuthorizedFileFormats = formatedAuthorizedFileFormats.map(format => {
          return getMime(format);
        });
        formatedAuthorizedFileFormats = formatedAuthorizedFileFormats.join(',');

        props.accept = formatedAuthorizedFileFormats;
        break;

      //
      default:
        break;
    }
  });

  if (!hasPlaceholder) {
    props.value = field.values;
  }

  return props;
}

export function getOptionsFromFieldValuesProps(field: FieldsType) {
  switch (field.type) {
    case 'select':
    case 'select*':
      if (field && field.values) {
        return field.values.map<any>((value, index) => {
          return {
            value: index,
            label: value
          };
        });
      } else {
        return [];
      }
    default:
      return null;
  }
}
